function providers() {
    // todo verify if providers page
    const geoZip = localStorage.getItem('MM_ZIP');
    // const provider = $('input[name="provider"]').val();
    // $('.provider-card').show();

    $('.single-card').each((i, e) => {
        const provider = e.dataset.slug;
        $(e).show();
        $.ajax({
            dataType: 'json',
            url: `/wp/wp-admin/admin-ajax.php?action=checkZipProvider&zip=${geoZip}&provider=${provider}`,
            success: (res) => {
                if (res.result !== 'no') {
                    if (res.coverage > 0) {
                        $('.zipProviderCheckZip').html(geoZip);
                        $('.zipProviderCheckCoverage').html(`${res.coverage}%`);
                        $('.zipProviderCheck').removeClass('hidden');
                    } else {
                        $('.zipProviderCheckZip').html(geoZip);
                        $('.zipProviderCheck').removeClass('hidden');
                    }
                }
            },
            error: () => {
                console.log('Providers Zip lookup error');
            },
        });
    });
}

export { providers };
